import { useMemoizedFn, useMount, useSize, useUnmount } from 'ahooks';
import { Typography } from 'antd';
import classNames from 'classnames';
import { JobconfigSupplierComparisonArrowIcon } from 'components/Icons';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxMoney } from 'components/RevxMoney';
import { useEffect, useMemo, useRef, useState } from 'react';
import ComparisonBadge, { getComparisonBadgeColor } from './ComparisonBadge';
import './ComparisonPress.less';

interface PressItem {
  pressCharge?: number;
  pressCode: string;
  pressId: number;
  pressName: string;
  name: string;
}
interface Props {
  onChange?: (x: string | number) => void;
  value?: number;
  optionArr: PressItem[];
  disabled?: boolean;
}

export const ComparisonPress = (props: Props) => {
  const { onChange, value, optionArr, disabled } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [curValue, setCurvalue] = useState<PressItem>();

  const toggleContainer = useRef<HTMLDivElement>(null);
  const size = useSize(toggleContainer);

  useEffect(() => {
    setCurvalue(optionArr.find((item) => item.pressId === value));
  }, [value, optionArr]);

  const onClickHandle = () => {
    if (!disabled) {
      setTimeout(() => {
        setIsOpen((e) => !e);
      });
    }
  };

  const onClickOutsideHandle = useMemoizedFn((e: any) => {
    if (toggleContainer.current && toggleContainer.current['contains']) {
      if (
        isOpen &&
        toggleContainer?.current &&
        !toggleContainer?.current?.contains(e.target)
      ) {
        setIsOpen(false);
      }
    }
  });

  useMount(() => {
    window.addEventListener('click', onClickOutsideHandle);
  });

  useUnmount(() => {
    window.removeEventListener('click', onClickOutsideHandle);
  });

  const onChangeHandle = (e: PressItem) => {
    setIsOpen(false);
    setCurvalue(e);
    if (typeof onChange === 'function') {
      onChange(e.pressId);
    }
  };

  const colorIndex = useMemo(() => {
    return value || 0;
  }, [value]);

  const choiceItemClass = useMemo(() => {
    return `comparison-selector-select-bottom ${classNames(
      'comparison-badge',
      getComparisonBadgeColor(colorIndex),
      size
    )} ${disabled ? 'disabled' : ''}`;
  }, [colorIndex, size, disabled]);

  return (
    <>
      <div className="comparison-selector" ref={toggleContainer}>
        <RevxFlexLayout
          direction="column"
          className={`comparison-selector-select ${disabled ? 'disabled' : ''}`}
          onClick={() => onClickHandle()}
        >
          {/* {curValue} */}
          <div className="comparison-selector-select-container">
            <RevxFlexLayout justify="space-between" align="center">
              <RevxMoney value={curValue?.pressCharge || 0} />
              <JobconfigSupplierComparisonArrowIcon
                className={isOpen ? 'comparison-selector-select-icon' : ''}
              />
            </RevxFlexLayout>
            <div className="comparison-selector-select-container-name">
              <Typography.Title
                style={{
                  fontSize: '13px',
                  marginBottom: 0,
                  maxWidth: `${(size?.width || 160) - 10}px`,
                }}
                ellipsis={{
                  tooltip: curValue?.name,
                }}
              >
                {curValue?.name}
              </Typography.Title>
            </div>
          </div>
          <div className={choiceItemClass}>
            <Typography.Title
              style={{
                fontSize: '13px',
                marginBottom: 0,
                maxWidth: `${(size?.width || 160) - 10}px`,
              }}
              ellipsis={{
                tooltip: curValue?.pressName,
              }}
            >
              {curValue?.pressName}
            </Typography.Title>
          </div>
        </RevxFlexLayout>
        {isOpen ? (
          <div className="comparison-selector-opttion">
            {optionArr.map((option, index) => {
              return (
                <RevxFlexLayout
                  justify="space-between"
                  className="comparison-selector-opttion-item"
                  onClick={() => onChangeHandle(option)}
                  style={{
                    width: (size?.width || 0) - 20,
                  }}
                >
                  <RevxFlexLayout direction="column" align="top">
                    <div>{option.name}</div>
                    {/* <RevxMoney value={165.96} /> */}
                  </RevxFlexLayout>
                  <ComparisonBadge
                    name={option.pressCode}
                    color={getComparisonBadgeColor(option.pressId)}
                  />
                  {/* <RevxFlexLayout
                    className="comparison-selector-opttion-item-right"
                    justify="justify-center"
                    align="center"
                  >
                    {option.pressName}
                  </RevxFlexLayout> */}
                  {/* <NameBadge  name={'Straight Web'} /> */}
                </RevxFlexLayout>
              );
            })}
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};
